import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import "modules/CommunicationSettings/CustomerCom.scss";

import type { CommunicationSetting } from "models";

type KioskProps = {
  tabId: string;
};

const FormHelper = createFormHelper<CommunicationSetting>();

export const Kiosk = ({ tabId }: KioskProps) => {
  const { t } = useTranslation();
  const { setValue, watch } = FormHelper.useFormContext();

  const [is_customer_name_in_kiosk_checkin_enabled, is_customer_signature_in_kiosk_checkin_enabled] = watch([
    "is_customer_name_in_kiosk_checkin_enabled",
    "is_customer_signature_in_kiosk_checkin_enabled"
  ]);

  const handleKioskCheckinCheckboxChange = (name: keyof CommunicationSetting) => (value?: string | number | boolean | (string | number | boolean)[]) => {
    const checked = Boolean(value);

    if (!checked && (!is_customer_name_in_kiosk_checkin_enabled || !is_customer_signature_in_kiosk_checkin_enabled)) {
      setValue("is_customer_signature_in_kiosk_checkin_enabled", true);
      setValue("is_customer_name_in_kiosk_checkin_enabled", true);
      setValue(name, checked);
    }
  };

  return (
    <Element name={tabId} className="customer-com-wrapper">
      <h3>{t("v8_kiosk", "Kiosk")}</h3>
      <div>
        <Form.Group className="mt-22 file">
          <Form.Field width={8} className="pr-12">
            <span className="items-center">
              <FormHelper.Field.Checkbox
                name="is_customer_name_in_kiosk_checkin_enabled"
                label={t("v8_customer_name_in_kiosk_check_in", "Customer name in kiosk checkin")}
                onChange={handleKioskCheckinCheckboxChange("is_customer_name_in_kiosk_checkin_enabled")}
              />
            </span>

            <span className="items-center">
              <FormHelper.Field.Checkbox
                name="is_customer_signature_in_kiosk_checkin_enabled"
                label={t("v8_customer_signature_in_kiosk_check_in", "Customer signature in kiosk checkin")}
                onChange={handleKioskCheckinCheckboxChange("is_customer_signature_in_kiosk_checkin_enabled")}
              />
            </span>

            <span className="items-center">
              <FormHelper.Field.Checkbox name="show_parking_location_note_on_kiosk_check_in" label={t("v8_show_parking_location_note", "Show parking location note")} />
            </span>
          </Form.Field>
        </Form.Group>
      </div>
    </Element>
  );
};
